module.exports = __webpack_public_path__ + "img/Italy.1b596a87.png";